import React from 'react'
import { Link } from 'react-router-dom'
import { FaSignOutAlt } from 'react-icons/fa'
import { IconType } from 'react-icons'
import Auth from './Auth'
import { useAuth } from '../context/AuthContext'

const LoginFormComponent: React.FC = () => {
	const { profile, handleLogin, handleLogout } = useAuth()

	return (
		<section className='bg-sky-50 shadow-lg animate-slide-up md:col-span-1 height-100 flex flex-col justify-center'>
			{profile ? (
				<div className='p-6 rounded-lg grid place-items-center'>
					<h2 className='text-lg font-bold text-sky-800 mb-4'>Account Panel</h2>
					<p className='text-sky-700'>
						Welcome, {profile?.username || 'User'}!
					</p>
					<Link
						to='/dashboard'
						className='mt-4 bg-sky-600 hover:bg-sky-700 text-white font-semibold py-4 px-8 rounded flex items-center space-x-2 transition duration-300 w-full justify-center'
					>
						User Panel
					</Link>
					<button
						onClick={handleLogout}
						className='mt-4 bg-sky-600 hover:bg-sky-700 text-white font-semibold py-4 px-8 rounded flex items-center space-x-2 transition duration-300 w-full justify-center'
					>
						{(FaSignOutAlt as IconType)({})} <span>Logout</span>
					</button>
				</div>
			) : (
				<div className='p-6 grid place-items-center'>
					<h2 className='text-lg font-bold text-sky-800 mb-4'>LOGIN</h2>
					<Auth onLogin={handleLogin} />
				</div>
			)}
		</section>
	)
}

export default LoginFormComponent
